<template lang="pug">
  .pho-file-upload
    PhoFileInput(v-if="!isUploading" :accept="accept" @onChange="onChange")
      template(v-slot:activator="{on}")
        slot(name="activator" :on="on")
    PhoFileUploadPreview(v-else linear :file="lazyValue" @onCancel="onCancelUpload")
    PhoValidationProvider.text-center.d-block(:name="name" :rules="rules")
      input(v-model="lazyValue" type="hidden")
</template>

<script>
import { ref, computed } from 'vue';
import { useFileUploadManager } from '@/helpers/misc/file-upload';

import PhoValidationProvider from '../PhoValidationProvider.vue';
import PhoFileInput from './PhoFileInput.vue';
import PhoFileUploadPreview from './PhoFileUploadPreview.vue';

export default {
  name: 'PhoSingleFileUpload',
  components: {
    PhoFileInput,
    PhoFileUploadPreview,
    PhoValidationProvider,
  },
  props: {
    accept: {
      type: String,
      default: '*',
    },
    extensions: {
      type: String,
      default: '*',
    },
    validate: {
      type: Function,
      default: undefined,
    },
    transform: {
      type: Function,
      default: file => ({
        path: file.data.relativePath,
      }),
    },
    name: {
      type: String,
      default: '',
    },
    rules: {
      type: String,
      default: '',
    },
    uploadMethod: {
      type: Number,
      default: null,
    },
    // false: upload servisi dosyayı webp'ye çevirmesin
    convert: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['onFileUploaded'],
  setup(props, { emit }) {
    const lazyValue = ref(null);

    const updateValue = value => {
      emit('onFileUploaded', value);
    };

    const isUploading = computed(() => !!lazyValue.value && lazyValue.value.isUploading);

    const onCompleted = () => {
      updateValue(lazyValue.value);
    };

    const {
      uploadFiles,
      cancelAll: cancel,
      cancelUpload,
      isFileUploading,
    } = useFileUploadManager({
      multiple: false,
      extensions: props.extensions,
      validateFile: props.validate,
      transform: props.transform,
      model: lazyValue,
      method: props.uploadMethod,
      onCompleted,
    });

    const onChange = async ({ target }) => {
      if (target.files) {
        await uploadFiles(Array.from(target.files), props.convert);
        target.value = null;
      }
    };

    const onCancelUpload = id => {
      cancelUpload(id);
    };

    return {
      lazyValue,
      updateValue,
      isUploading,
      onCompleted,
      onChange,
      onCancelUpload,
      cancel,
      isFileUploading,
    };
  },
};
</script>
